import React from 'react'
import "./styles/animation.css"

const Animation = () => {

  return (
      <div className="main" id="loadanimation">
      <span id="pro"></span>
      <span id="one"></span>
      <span id="two"></span>
      <span id="three"></span>
    </div>
  )
}

export default Animation